import * as React from 'react';

export const IconStandard = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 16" width="14" height="16">
    {/* tslint:disable-next-line:max-line-length */}
    <path fillRule="evenodd" d="M7 0L0 4V12L7 16L14 12V4L7 0ZM7 4L3.5 6L7 8L10.5 6L7 4Z" fill="#ff7e00" />
  </svg>
);
